const localForage = require('localforage');

/**
 * @param {object} params.window - DOM window object
 * @returns {{ updateBrowserLocation:function }}
 */
module.exports = ({ window }) => {
	localForage.config({
		name        : 'RevolutionParts',
		version     : 1.0,
		storeName   : 'garage_store', // Should be alphanumeric, with underscores.
		description : 'Selected Vehicles For Revolution parts'
	});

	const GARAGE_SESSION = 'myGarage';

	return {
		set: (garage) => {
			return localForage.setItem(GARAGE_SESSION, garage);
		},

		get: () => {
			return localForage.getItem(GARAGE_SESSION);
		},

		removeAll: () => {
			localForage.setItem(GARAGE_SESSION, []);
		},

		clearDb: () => {
			return localForage.clear();
		}
	};
};
